module.exports = __webpack_public_path__ + "RoushanKumar-592e0b0c.webp";